import React from 'react';
import { Redirect } from "react-router-dom";
import Navbarmenu from "../Components/Navbarmenu";
import {
    Route,
    useRouteMatch,
    Switch
  } from "react-router-dom";
import CensoPage from './CensoPage';
import ProceduresPage from './ProceduresPage';
import DirectionPage from './DirectionPage';
import PdfAccountPage from './PdfAccountPage';

export default function DashboardPage(props)
{
    if (!props.user)
    {
        return(
        <Redirect
        to={{
        pathname: "/login"}}/>
        );
    } else {
        return(
            <Dashboard {...props} LogOut={() => props.LogOut()}/>
        );
    }
}

function Dashboard(props)
{
    let { path } = useRouteMatch();

    return(
        <div id="dashboard">
            <Navbarmenu {...props} 
                OnLogout={() => props.LogOut()}
                SwitchHosp={() => props.SwitchHosp()}/>
            <div className="ptnv h100 ofscroll">
                <Switch location={props.location}>
                    <Route exact path={path}>
                        <CensoPage {...props}/>
                    </Route>
                    <Route path={`${path}/procedures`}>
                        <ProceduresPage {...props}/>
                    </Route>
                    <Route path={`${path}/direction`}>
                        <DirectionPage {...props}/>
                    </Route>
                    <Route path={`${path}/cuenta/:idcuenta`}>
                        <PdfAccountPage/>
                    </Route>
                </Switch>
            </div>
        </div>
    );
}